import axios from 'axios'

import { detectEnvironment, Environment } from '../config/config'

const csrfCookiePrefixLocal = 'csrftoken='
// Keep in sync with CSRF_COOKIE_NAME in cloudtrucks/settings.py
export const csrfCookiePrefixProd = '__Secure-csrftoken-v2='
//axios interceptor to add csrf token to every request
export function setCsrfHeader() {
  axios.interceptors.request.use((config) => {
    if (config.method !== 'get') {
      let token = getCsrfCookieToken()
      config.headers['Content-Type'] = 'application/json'
      config.headers['x-csrftoken'] = token
    }
    return config
  })
}

export function getCsrfCookieToken() {
  if (!document.cookie) {
    return ''
  }
  const csrfCookies = document.cookie
    .split(';')
    .map((c) => c.trim())
    .filter((c) => c.startsWith(csrfCookiePrefixProd) || c.startsWith(csrfCookiePrefixLocal))

  if (csrfCookies.length === 0) {
    return ''
  }
  return decodeURIComponent(csrfCookies[0].split('=')[1]).toString()
}

export function maybeSetUpBaseDomain() {
  const env = detectEnvironment()
  if (env !== Environment.PREVIEW) {
    return
  }

  axios.defaults.withCredentials = true
  axios.interceptors.request.use((config) => {
    // Redirect requests on preview to staging api
    if (!config.url?.startsWith('http')) {
      config.url = `https://console.cloudtrucks-staging.com${config.url}`
      config.headers['X-From'] = 'netlify'
    }
    return config
  })
}
